import { render, staticRenderFns } from "./LoadMoreProductsButton.vue?vue&type=template&id=9ee56310&scoped=true&"
import script from "./LoadMoreProductsButton.vue?vue&type=script&lang=js&"
export * from "./LoadMoreProductsButton.vue?vue&type=script&lang=js&"
import style0 from "../NextButton/next-button.scss?vue&type=style&index=0&id=9ee56310&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee56310",
  null
  
)

export default component.exports